import React from 'react'
import { useParams } from 'react-router'
import { jobPosts } from '../Utils/dummy_data'
import { job_posts_collection } from '../Utils/utils'
import JobApplicationForm from '../Components/Career/ApplicationForm/ApplicationForm'

const location_icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
</svg>

const map_icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.
    38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
</svg>
const exp_icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
</svg>
const clock_icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
const calendar_icon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
</svg>


const SummeryCard = ({ icon, title, value }) => {
    return <> <div className='col-span-2'>
        {icon}

    </div>
        <div className='col-span-10'>
            <p className='font-semibold '>{title}</p>
            <p className='text-[#4A5568]'>{value}</p>
        </div>
    </>

}

const JobPostDetails = () => {
    const id = useParams().id
    const job_post = job_posts_collection.filter(item => {
        return item.job_post_id == id
    })[0] || null;

    return (
        <div className='h-full w-full bg-[#fcfdfd]'>
            <div className='relative h-[30vh] w-full bg-[#eff1f7]'>
                <div className="absolute hidden sm:block radial-bg" ></div>
            </div>

            <div className=' px-[10%] flex  -translate-y-24'>
                <div className='w-full p-10 bg-white'>
                    {/* Title */}
                    <div className=' rounded-md py-10 translate-x-4 w-[80%] '>
                        <h1 className='text-3xl'>React JS Developer</h1>
                        <p className='text-sm'>RedQ Team is a future focused full-stack software development agency. We are looking for someone who have in-depth knowledge of JavaScript and React concepts, excellent front-end coding skills, and a good understanding of progressive web applications. Strong knowledge on CSS Flexbox , CSS Grid & Github is also needed. A dynamic person who is proficient understanding of client-side scripting and JavaScript framework. Knowledge about Tailwind, typescript is a plus. Basic understanding of server-side CSS pre-processing platforms, such as LESS and SASS</p>
                    </div>
                    {/* REquirements */}
                    <div>
                        <h2>Requirements & Job Responsibilites</h2>
                        <ul className=' list-disc text-xs'>
                            <li>You must have good understanding of Git & </li>
                            <li>Nice to have knowledge on WordPress & Node JS</li>
                            <li>Optimize application for maximum speed and scalability</li>
                            <li>Collaborate with other team members and stakeholders</li>

                        </ul>
                    </div>

                    {/* Benefits */}
                    <div>
                        <h2>Other Benefits</h2>
                        <ul className=' list-disc text-xs'>
                            <li>You must have good understanding of Git & </li>
                            <li>Nice to have knowledge on WordPress & Node JS</li>
                            <li>Optimize application for maximum speed and scalability</li>
                            <li>Collaborate with other team members and stakeholders</li>

                        </ul>
                    </div>
                    {/* Education */}
                    <div>
                        <h2>Education</h2>
                        <ul className=' list-disc text-xs'>
                            <li>You must have good understanding of Git & </li>
                            <li>Nice to have knowledge on WordPress & Node JS</li>
                            <li>Optimize application for maximum speed and scalability</li>
                            <li>Collaborate with other team members and stakeholders</li>

                        </ul>
                    </div>
                    {/* salary */}
                    <div>
                        <h2>salary</h2>
                        <ul className=' list-disc text-xs'>
                            <li>70,000 - 90,000 BDT/Month</li>


                        </ul>
                    </div>
                    {/* apply */}
                    <div className='py-2'>
                        <button className='px-8 py-3 bg-black text-white capitalize rounded-lg font-semibold'>Apply Now</button>
                    </div>
                </div>
                <div className='w-[30%] bg-[#f7f8fa] p-10'>
                    {/* Button  */}
                    <div className='py-2'>
                        <button className='px-8 py-3 bg-black text-white capitalize rounded-lg font-semibold w-full'>Apply Now</button>
                    </div>
                    <div className='grid grid-cols-12 gap-8 py-10'>

                        <SummeryCard icon={location_icon} title={"Location"} value={"Work from home / Remote"} />
                        <SummeryCard icon={map_icon} title={'Job Type'} value={'Full Time'} />

                        <SummeryCard icon={exp_icon} title={'Experience'} value={'Experience'} />
                        <SummeryCard icon={clock_icon} title={'Working Hours'} value={'Working Hours'} />
                        <SummeryCard icon={calendar_icon} title={'Working Days'} value={'Full Time'} />

                    </div>
                </div>
            </div>
            <div className='  py-8 px-[10%] w-full'>
                <div className='bg-[#eff1f7]  rounded-lg p-8 '>
                    {/*    <h2>Apply For this Post</h2> */}
                    <JobApplicationForm />
                </div>


            </div>

        </div>
    )
}

export default JobPostDetails